import { loc } from "../../../core/utils"
import LinkUrl from "../../atoms/LinkUrl"
import BplsLogoForFooter from "./../../../asset/img/bpls/bpls-signature.svg"
import "./styles.css"
import { shape } from "prop-types"
import React from "react"

export default function BplsFooter({ tunnelData }) {
  const { legalMentionBaseBloc } = tunnelData

  const [footerBaseText, legalMention, privacyPolicy, cookiesPolicy] = legalMentionBaseBloc

  return (
    <footer className="padding-45">
      <div className="d-flex flex-column gap-2 gap-md-4 text-center text-md-left justify-content-md-between flex-md-wrap">
        <p className="mr-2 mr-md-0 mb-md-2">
          {loc(footerBaseText.description, {
            legalMention: [
              <LinkUrl
                key={legalMention.description}
                description={loc(legalMention.description)}
                title={loc(legalMention.linkTitle)}
                url={legalMention.url}
                className={"link"}
              />
            ],
            privacyPolicy: [
              <LinkUrl
                key={privacyPolicy.description}
                description={loc(privacyPolicy.description)}
                title={loc(privacyPolicy.linkTitle)}
                url={privacyPolicy.url}
                className={"link"}
              />
            ],
            cookiesPolicy: [
              <LinkUrl
                key={cookiesPolicy.description}
                description={loc(cookiesPolicy.description)}
                title={loc(cookiesPolicy.linkTitle)}
                url={cookiesPolicy.url}
                className={"link"}
              />
            ]
          })}
        </p>
        <div className="d-block d-md-none">
          <img src={BplsLogoForFooter} style={{ height: "1rem" }} alt="no" />
        </div>
        <span>*Le financement d'équipements d’un monde qui change</span>
      </div>
    </footer>
  )
}

BplsFooter.propTypes = {
  tunnelData: shape({})
}
